import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getLangFromPath, isLocalizablePath } from '../utils/langPath';

// Keeps the UI language in step with the URL on browser back/forward
// between /x and /ru/x. Pages without a Russian URL keep the current language.
export default function LanguageRouteSync() {
  const { pathname } = useLocation();
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    if (!isLocalizablePath(pathname)) return;
    const urlLang = getLangFromPath(pathname);
    if (urlLang !== language) setLanguage(urlLang);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
